export default "__VITE_ASSET__D7a4tO0H__"